import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { colors } from '@global/constants'

export const IntegrationErrorMessage = styled.div`
  background-color: ${colors.gray.light};
  padding: 16px;
  margin-top: 16px;
`

export const SubSection = styled.div`
  display: flex;
  flex-direction: row;
`

export const noWrapButton = css`
  white-space: nowrap;
`

export const marginRight = css`
  margin-right: 8px;
`

export const flex = css`
  display: flex;
`

export const flexItem = css`
  flex: 1;
`

export const flexShrink = css`
  flex-shrink: 1;
`
